import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {ReportUtils} from '../../../../libraries/report-utils';
import {
  PathExplorerReportFiltersComponent
} from "../../../path-explorer-report-filters/path-explorer-report-filters.component";
import {ParamsActionsService} from "../../../../services/params-actions.service";
import {ParamConfig} from "../../../../interfaces/params";
import {ReportStore} from "../../../../store/report/report.store";
import {filter, tap} from 'rxjs/operators';
import {AdRequestParams} from '../../../../interfaces/ad-reports';

@Component({
  selector: 'app-params-actions',
  templateUrl: './params-actions.component.html',
  styleUrls: ['./params-actions.component.scss']
})
export class ParamsActionsComponent implements OnInit, OnDestroy {
  @ViewChild(PathExplorerReportFiltersComponent) private readonly _filtersC: PathExplorerReportFiltersComponent;

  @Input('actionsDef') set setActionsDef(actionsDef: Array<ParamConfig>) {
    this.actionsDef = actionsDef;

    if (actionsDef.length) {
      this._reportStoreStateSubs = combineLatest([
        this._reportStore.initialized$,
        this._reportStore.requestParams$
      ])
        .pipe(
          filter(([initialized, requestParams]: [boolean, Partial<AdRequestParams>]) => initialized && requestParams !== null),
          tap(([initialized, requestParams]: [boolean, Partial<AdRequestParams>]): void => {
            for (const config of this.actionsDef) {
              switch (config.controlName) {
                case 'filters':
                case 'compare':
                  this.form.get(config.controlName).setValue(requestParams[config.controlName] || {}, { emitEvent: true });
                  break;
              }
            }
          })
        )
        .subscribe();
    }
  };

  @Input('form') public form: FormGroup;

  public nbFilters: number = null;
  public compare: number = 0;
  public actionsDef: Array<ParamConfig>;

  private _formValueChangesSubs: Subscription;
  private _onFiltersSubs: Subscription;
  private _reportStoreStateSubs: Subscription;

  public readonly publicMode$: Observable<boolean> = this._reportStore.publicMode$;

  constructor(
    private readonly _paramsActionsS: ParamsActionsService,
    private readonly _reportStore: ReportStore
  ) {}

  ngOnInit(): void {
    this._formValueChangesSubs = this.form.valueChanges.subscribe((value: any): void => {
      if (value.hasOwnProperty('filters')) {
        this.getNbFilters(value.filters);
      }
      if (value.hasOwnProperty('compare') && value.compare) {
        this.compare = value.compare.on;
      }
    });

    this._onFiltersSubs = this._paramsActionsS.onFilter.subscribe((): void => {
      this._filtersC.open();
    });
  }

  ngOnDestroy(): void {
    ReportUtils.unsubscribe(this._formValueChangesSubs);
    ReportUtils.unsubscribe(this._onFiltersSubs);
    ReportUtils.unsubscribe(this._reportStoreStateSubs);
  }

  private getNbFilters(filters: any): void {
    let nbFilters: number = 0;

    for (const key in filters) {
      nbFilters += filters[key].length && filters[key].length || 0;
    }

    this.nbFilters = nbFilters || null;
    this._paramsActionsS.nbFilters = this.nbFilters;
  }

  public onParams(key: string, data: any): void {
    this.form.get(key).setValue(data);
  }

  public onSave(action: ParamConfig): void {
    this._reportStore.saveLocalStorage(action.key);
  }

}
